<template>
  <div v-if="valueItem.length > 200">
    <v-dialog v-model="dialog" scrollable width="800" class="pa-4">
      <template v-slot:activator="{ on, attrs }">
        <p class="text-body-2 mb-0" v-bind="attrs" v-on="on">
          {{ valueItem.substring(0, 100) }}
          <span class="red--text">... {{ $t("generic.seeMore") }}</span>
        </p>
      </template>
      <!-- pop up -->
      <v-card>
        <v-card-title class="white--text text-h5 primary">
          Détails
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 450px" class="py-4 text-body-1">
          {{ valueItem }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <p class="text-body-2 mb-0">
      {{ valueItem }}
    </p>
  </div>
</template>

<style scoped>
.perso_card {
  border: 1px solid rgba(202, 5, 56, 0.4);
}
</style>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    valueItem: String,
  },
  methods: {},
};
</script>